import React, { useState, useEffect } from "react";
import { Row, Col, Button } from "react-bootstrap";
import "./deviceLogs.scss";
import TextInputField from "../../components/ui/textInputField";
import { useDeviceLogs } from "./useDeviceLogs";

const DeviceLogs = () => {
  const [deviceId, setDeviceId] = useState<string>("");

  const { handleRetrieveLogsButtonClick, isDownloadDisabled, handleDownloadLogs } = useDeviceLogs({
    deviceId,
  });

  return (
    <div className="DeviceLogs_container">
      <div className="DeviceLogs_content">
        <div className="DeviceLogs_header">
          <h1>Device Logs</h1>
        </div>
        <div className="DeviceLogs_body">
          <Row>
            <Col sm={12}>
              <div className='device-setup-content'>
                <Row>
                  <Col sm={5}>
                    <div className='device-setup-input'>
                      <TextInputField
                        heading='Device ID'
                        placeholder='Enter Device ID'
                        ariaLabel='device-id'
                        value={deviceId}
                        onChange={(e) => setDeviceId(e.target.value)}
                      />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col sm={3}>
                    <div className='device-setup-input'>
                      <div className='device-setup-btn-container'>
                        <Button
                          className='button-style-1'
                          onClick={handleRetrieveLogsButtonClick}
                        >
                          Retrieve logs
                        </Button>
                      </div>
                    </div>
                  </Col>
                  <Col sm={3}>
                    <div className='device-setup-input'>
                      <div className='device-setup-btn-container'>
                        <Button
                          className='button-style-1'
                          disabled={isDownloadDisabled}
                          onClick={handleDownloadLogs}
                        >
                          Download logs
                        </Button>
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
};

export default DeviceLogs;
